import React from 'react';
import firstStepConstants from '../common/Constants';
import { Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import AddressAutocomplete from '../common/AddressAutocomplete.js';
// import DeParamMovingURL from '../common/DeParamMovingURL.js';
import calculateAndStoreDistance from '../common/CalculateDistance.js';


class FirstStep extends React.Component {
  constructor(props) {
    super(props);

    // Setup save/read top component state
    this.saveTopState = props.saveTopState;
    this.readTopState = props.readTopState;

    // Get input variables from top state
    let savedStateFromTop = this.readTopState('firstStepState');

    //Setting up state variables from tor empty, with variable type
    this.state = {
      movingFromAddress: savedStateFromTop['movingFromAddress'] || {},
      movingToAddress: savedStateFromTop['movingToAddress'] || {},
      movingFromFlights: savedStateFromTop['movingFromFlights'] || {},
      movingTypeFrom: savedStateFromTop['movingTypeFrom'] || {},
      movingHomeSizeFrom: savedStateFromTop['movingHomeSizeFrom'] || {},
      movingFromElevator: savedStateFromTop['movingFromElevator'] || {},
      movingToFlights: savedStateFromTop['movingToFlights'] || {},
      movingTypeTo: savedStateFromTop['movingTypeTo'] || {},
      movingHomeSizeTo: savedStateFromTop['movingHomeSizeTo'] || {},
      movingToElevator: savedStateFromTop['movingToElevator'] || {},
      movingDate: savedStateFromTop['movingDate'] || null,
      pickupToDelivery: savedStateFromTop['pickupToDelivery'] ? savedStateFromTop['pickupToDelivery'] : 0,
      baseToPickup: savedStateFromTop['baseToPickup'] ? savedStateFromTop['baseToPickup'] : 0,
      deliveryState: savedStateFromTop['deliveryState'] ? savedStateFromTop['deliveryState'] : 0,
      pickupState: savedStateFromTop['pickupState'] ? savedStateFromTop['pickupState'] : 0,
      baseToDelivery: savedStateFromTop['baseToDelivery'] ? savedStateFromTop['baseToDelivery'] : 0,
      longestDistance: savedStateFromTop['longestDistance'] ? savedStateFromTop['longestDistance'] : 0,
      travelDuration: savedStateFromTop['travelDuration'] ? savedStateFromTop['travelDuration'] : 0,
      travelDurationBP: savedStateFromTop['travelDurationBP'] ? savedStateFromTop['travelDurationBP'] : 0,
      travelDurationDB: savedStateFromTop['travelDurationDB'] ? savedStateFromTop['travelDurationDB'] : 0,
      travelDurationPD: savedStateFromTop['travelDurationPD'] ? savedStateFromTop['travelDurationPD'] : 0,
      errorclass: 'before-error-validation',
    };

    //Binding functions
    this.onInputFieldChange = this.onInputFieldChange.bind(this);
    this.onInputSelectChange = this.onInputSelectChange.bind(this);
    this.onDateChange = this.onDateChange.bind(this);
    this.handleNext = this.handleNext.bind(this);
    this.calculateAndStoreDistance = calculateAndStoreDistance.bind(this);
    this.calculateDistances = this.calculateDistances.bind(this);
  }



  /**
* Validation and saving of input fields
* @param  {[type]} event [description]
* @return {[type]}       [description]
*/
  onInputSelectChange(event) {
    let { name, value } = event.target;
    let isFieldValid = false;
    let changeElevator = event.target.options[event.target.selectedIndex].dataset.elevator;
    let changeWalkup = event.target.options[event.target.selectedIndex].dataset.walkup;
    let changeState = {
      [name]: {
        'value': event.target.options[event.target.selectedIndex].value,
        'label': event.target.options[event.target.selectedIndex].text,
        walkup: changeWalkup,
        elevator: changeElevator
      }
    };

    switch (event.target.options[event.target.selectedIndex].text) {
      case "Apartment Building":
        if (name === "movingTypeFrom") {
          changeState = { ...changeState, movingFromElevator: { value: null }, movingFromFlights: { value: null } }
          document.getElementById("movingFromElevator").selectedIndex = 0;
          document.getElementById("movingFromFlights").selectedIndex = 0;
          document.getElementById("movingFromFlights1").selectedIndex = 0;
          document.getElementById("movingFromFlights2").selectedIndex = 0;

        } else {
          changeState = { ...changeState, movingToElevator: { value: null }, movingToFlights: { value: null } }
          document.getElementById("movingToElevator").selectedIndex = 0;
          document.getElementById("movingToFlights").selectedIndex = 0;
          document.getElementById("movingToFlights1").selectedIndex = 0;
          document.getElementById("movingToFlights2").selectedIndex = 0;

        }
        break;
      case "Multi Family Home":
        if (name === "movingTypeFrom") {
          changeState = { ...changeState, movingFromElevator: { 'value': "0", 'label': "No Elevator" }, movingFromFlights: { value: null } }
          document.getElementById("movingFromFlights").selectedIndex = 0;
        } else {
          changeState = { ...changeState, movingToElevator: { 'value': "0", 'label': "No Elevator" }, movingToFlights: { value: null } }
          document.getElementById("movingToFlights").selectedIndex = 0;
        }
        break;
      case "Private Home": case "Storage Facility":
        if (name === "movingTypeFrom") {
          changeState = { ...changeState, movingFromElevator: { 'value': "0", 'label': "No Elevator" }, movingFromFlights: { 'value': "0", 'label': "No Walkup" } }


        } else {
          changeState = { ...changeState, movingToElevator: { 'value': "0", 'label': "No Elevator" }, movingToFlights: { 'value': "0", 'label': "No Walkup" } }
        }
        break;
      default:
        console.log("nnonon")
        break;
    }

    this.setState(changeState);

    isFieldValid = value ? true : false;

    event.target.className = (isFieldValid ? 'input-valid' : 'input-error');
  }


  /**
* Validation and saving of input fields
* @param  {[type]} event [description]
* @return {[type]}       [description]
*/
  onInputFieldChange(event) {
    let { name, type } = event.target;
    let isFieldValid = false;
    // Text input
    if (type === 'text') {
      let oldAddressState = this.state[name];
      oldAddressState['isValid'] = false;
      this.setState(oldAddressState);
      isFieldValid = false;
    }

    // Dropdown input
    else {
      let { name, value } = event.target;
      let movingFromFlights = {}
      let movingFlightsTo = {}
      if (name === "movingFromElevator") {
        movingFromFlights = { value: null }
        document.getElementById("movingFromFlights").selectedIndex = 0;
        document.getElementById("movingFromFlights1").selectedIndex = 0;
        document.getElementById("movingFromFlights2").selectedIndex = 0;
        this.setState({
          [name]: { 'value': event.target.options[event.target.selectedIndex].value, 'label': event.target.options[event.target.selectedIndex].text },
          movingFromFlights: movingFromFlights
        });
      }
      else if (name === "movingToElevator") {
        movingFlightsTo = { value: null }
        document.getElementById("movingToFlights").selectedIndex = 0;
        document.getElementById("movingToFlights1").selectedIndex = 0;
        document.getElementById("movingToFlights2").selectedIndex = 0;
        this.setState({
          [name]: { 'value': event.target.options[event.target.selectedIndex].value, 'label': event.target.options[event.target.selectedIndex].text },
          movingFlightsTo: movingFlightsTo
        });
      } else {
        this.setState({
          [name]: { 'value': event.target.options[event.target.selectedIndex].value, 'label': event.target.options[event.target.selectedIndex].text },
        });

      }


      isFieldValid = value ? true : false;
    }
    event.target.className = (isFieldValid ? 'input-valid' : 'input-error');
  }

  /**
   * Validation and saving of Date field
   * @param  {[type]} date [description]
   * @return {[type]}      [description]
   */
  onDateChange(date) {
    this.state.movingDate = date;
    this.setState({
      movingDate: date.format('YYYY-MM-DD')
    });
    date.className = ('input-valid');
  }



  calculateDistances() {

    // If both addreses are defined calculate distances
    if (this.state.movingFromAddress.value && this.state.movingToAddress.value) {

      //Define location parameters for distance calculation
      let base = firstStepConstants.baseLocation;
      let pickup = this.state.movingFromAddress.value;
      let delivery = this.state.movingToAddress.value;
      let pickupState = this.state.movingFromAddress.cityAndState.state;
      let deliveryState = this.state.movingToAddress.cityAndState.state;
      // We need this function because just passing setState to the calculate function is not working dunno why
      const firstStepSetState = (newFirstStepState, callback) => {
        this.setState(newFirstStepState, callback);
      }

      // Calling distance calculation function for all three cases
      this.calculateAndStoreDistance(pickup, delivery, firstStepSetState, 'pickupToDelivery', () => calculationCallback('pickupToDelivery'));
      this.calculateAndStoreDistance(base, pickup, firstStepSetState, 'baseToPickup', () => calculationCallback('baseToPickup'));
      this.calculateAndStoreDistance(base, delivery, firstStepSetState, 'baseToDelivery', () => calculationCallback('baseToDelivery'));


      // After calculating distance with asinch matrix service calling Callback function to save states and calc most far away distance
      const calculationCallback = (staPrintovati) => {

        // Calculate Travel time Base to Pickup + Base to Delivery
        let travelDuration = 0;
        travelDuration = (this.state.baseToPickup.timeEstimate + this.state.baseToDelivery.timeEstimate);

        let longestDistance = 0;
        if (this.state.baseToDelivery.distance >= this.state.baseToPickup.distance && this.state.baseToDelivery.distance >= this.state.pickupToDelivery.distance) {
          longestDistance = this.state.baseToDelivery.distance;
        }
        else if (this.state.baseToPickup.distance >= this.state.baseToDelivery.distance && this.state.baseToPickup.distance >= this.state.pickupToDelivery.distance) {
          longestDistance = this.state.baseToPickup.distance;
        }
        else {
          longestDistance = this.state.pickupToDelivery.distance;
        }

        this.setState({
          longestDistance: longestDistance,
          travelDuration: travelDuration,
          travelDurationBP: this.state.baseToPickup.timeEstimate,
          travelDurationDB: this.state.baseToDelivery.timeEstimate,
          travelDurationPD: this.state.pickupToDelivery.timeEstimate,
          deliveryState: deliveryState,
          pickupState: pickupState,
        })
      }
    }
  }

  /**
   * Validating all fiedls, saving First Step state to Top state
   * and proceeding to next step
   * @param  {[type]} event [description]
   * @return {[type]}       [description]
   */
  handleNext(event) {

    event.preventDefault();

    // If all fields are valid calculate distance and proceed to the next step.
    if (
      this.state.movingFromAddress.isValid &&
      this.state.movingToAddress.isValid &&
      this.state.movingFromFlights.value &&
      this.state.movingToFlights.value &&
      this.state.movingFromElevator &&
      this.state.movingToElevator &&
      this.state.movingTypeFrom.value &&
      this.state.movingTypeTo.value &&
      this.state.movingDate) {

      // Saving current state to top state and going to next step
      const calcFormAnchor = (window.scrollY + document.getElementById('calcForm').getBoundingClientRect().top - 200);
      const activeStep = this.readTopState('activeStep');
      this.saveTopState({
        activeStep: activeStep + 1,
        firstStepState: this.state,
      }, () => window.scrollTo(0, calcFormAnchor));

    }
    // If fields are not valid show errors
    else {
      this.setState({ errorclass: 'input-error' });
    }

  };


  /**
   * Inititate autocomplete when the component renders
   * @return {[type]} [description]
   */
  componentDidMount() {
    if (document.getElementById("second-step-change")) {
      if (document.querySelector(".second-step-expand").classList.contains("second-step-expandthis")) {
        document.querySelector(".second-step-expand").classList.remove("second-step-expandthis");
      }
      if (document.querySelector(".second-step-hide").classList.contains("second-step-hidethis")) {
        document.querySelector(".second-step-hide").classList.remove("second-step-hidethis");
      }

    }
    if (document.querySelector(".hero-section")) {
      if (document.querySelector(".hero-section").classList.contains("second-hero-section")) {
        document.querySelector(".hero-section").classList.add("second-hero-section");
      }
    }

    /**FRONT END BETWEEN STEPS STYLE**/

    // Get the from/to fields from DOM
    const inputFrom = document.getElementById('movingFromAddress');
    const inputTo = document.getElementById('movingToAddress');

    // Inititate autocomplete on address from
    AddressAutocomplete.initAutocomplete('inputFrom', inputFrom, (autocompleteService) => {

      const place = autocompleteService.getPlace();
      const cityAndState = AddressAutocomplete.getCityAndState(place.address_components);

      let searchFromPostalCode = "";
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType;
        var addressTypes = place.address_components[i].types;

        if (addressTypes["postal_code"]) {
          addressType = addressTypes["postal_code"];
        }
        
        if (addressType === "postal_code") {
          searchFromPostalCode = place.address_components[i].long_name;
        }
      }
      let streetAddress = "";
      if (place.name) {
        streetAddress = place.name;
      }

      // Save location info to state and calculate distances if both addreses are defined
      this.setState({
        movingFromAddress: {
          'value': place.geometry.location,
          'label': place.formatted_address,
          'isValid': true,
          'cityAndState': cityAndState,
          'searchFromPostalCode': searchFromPostalCode,
          'streetAddress': streetAddress
        }
      }, this.calculateDistances);

      // Set classname to valid
      inputFrom.className = "input-valid";

    });

    // Inititate autocomplete on address to
    AddressAutocomplete.initAutocomplete('inputTo', inputTo, (autocompleteService) => {

      const place = autocompleteService.getPlace();
      const cityAndState = AddressAutocomplete.getCityAndState(place.address_components);

      let searchToPostalCode = "";
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType;
        var addressTypes = place.address_components[i].types;

        if (addressTypes["postal_code"]) {
          addressType = addressTypes["postal_code"];
        }

        if (addressType === "postal_code") {
          searchToPostalCode = place.address_components[i].long_name;
        }
      }
      let streetAddress = "";
      if (place.name) {
        streetAddress = place.name;
      }

      // Save location info to state and calculate distances if both addreses are defined
      this.setState({
        movingToAddress: {
          'value': place.geometry.location,
          'label': place.formatted_address,
          'isValid': true,
          'cityAndState': cityAndState,
          'searchToPostalCode': searchToPostalCode,
          'streetAddress': streetAddress
        }
      }, this.calculateDistances);

      // this.setState({

      // })

      // Set classname to valid
      inputTo.className = "input-valid";

    });

    document.getElementById('thedate').setAttribute("autocomplete", "off");
    // $('.datepicker').on('click', function(e) {
    //    e.preventDefault();
    //    $(this).attr("autocomplete", "off");
    // });
  }

  render() {

    return (
      <div className="qc-first-step">
        <div className='form-title-wrap'>
          <h2 className='form-title'>Get Your Free Estimate Today!</h2>
        </div>
        <div className="show-grid">

          <div className="moving-form-wrapper">
            <div className="md-moving-from">
              <div className="md-calcheading-wrap">
                <h3 className="md-movingf-title md-move-c-title">Moving From</h3>
                <a href='https://www.google.com/maps/place/GI+Movers/@24.3644428,54.4856015,14.75z/data=!4m7!3m6!1s0x0:0xbfc66aab983da8f0!8m2!3d24.3650678!4d54.4853579!9m1!1b1' target="_blank" rel="noopener noreferrer" className="gmb-link" aria-label="View GI Movers reviews on Google Maps"></a>
              </div>
              <div className="md-moving-flex">
                <div className="md-moving-half">
                  <input id="movingFromAddress" type="text" name="movingFromAddress" placeholder="From Address (choose from suggestion)" defaultValue={this.state.movingFromAddress.label} className={!this.state.movingFromAddress.label !== '' ? this.state.errorclass : "untouched"} onChange={this.onInputFieldChange} />
                </div>
                <div className={this.state.movingTypeFrom.walkup === 'true' ? 'md-select-wrapper md-select-bg md-moving-real-half' : 'md-select-bg md-select-wrapper md-moving-half'}>
                  <select id="movingTypeFrom" name="movingTypeFrom" type="select" defaultValue={this.state.movingTypeFrom.value || 0} className={!this.state.movingTypeFrom.label ? this.state.errorclass : "untouched"} onChange={this.onInputSelectChange} aria-label="Type of structure you are moving from">
                    <option disabled value="0">Type of Structure</option>
                    {firstStepConstants.homeType.map(option =>
                      <option name="movingTypeFrom" key={option.value} value={option.value}>{option.label}</option>
                    )}
                  </select>
                </div>
                <div className="md-select-wrapper md-moving-half md-select-bg">
                  <select name="movingFromFlights" type="select" id="movingFromFlights" defaultValue={this.state.movingFromFlights.value || 0} className={!this.state.movingFromFlights.label ? this.state.errorclass : "untouched"} onChange={this.onInputFieldChange} aria-label="Floor you are moving from">
                    <option disabled value="0">Select Floor</option>
                    {firstStepConstants.moveSizesHouseFloor.map(option =>
                      <option name="movingFromFlights" key={option.value + 'flightsfrom1'} value={option.floor}>{option.label}</option>
                    )}
                  </select>
                </div>
              </div>


            </div>

            <div className="md-moving-to">
              <div className="md-calcheading-wrap">

                <h3 className="md-movingt-title md-move-c-title">Moving To</h3>
              </div>
              <div className="md-moving-flex">
                <div className="md-moving-half">
                  <input type="text" id="movingToAddress" name="movingToAddress" placeholder="To Address (choose from suggestion)" defaultValue={this.state.movingToAddress.label} className={!this.state.movingToAddress.label !== '' ? this.state.errorclass : "untouched"} onChange={this.onInputFieldChange} />
                </div>
                <div className='half-wrapper'>
                  <div className={this.state.movingTypeTo.walkup === 'true' ? 'md-select-bg md-select-wrapper md-moving-real-half' : 'md-select-bg md-select-wrapper md-moving-half'}>
                    <select name="movingTypeTo" type="select" defaultValue={this.state.movingTypeTo.value || 0} className={!this.state.movingTypeTo.label ? this.state.errorclass : "untouched"} onChange={this.onInputSelectChange} aria-label="Type of structure you are moving to">
                      <option disabled value="0">Type of Structure</option>
                      {firstStepConstants.homeType.map(option =>
                        <option name="movingTypeTo" key={option.value} value={option.value}>{option.label}</option>
                      )}
                    </select>
                  </div>
                  <div className="md-select-bg md-select-wrapper md-moving-half">
                    <select id="movingToFlights" name="movingToFlights" type="select" defaultValue={this.state.movingToFlights.value || 0} className={!this.state.movingToFlights.label ? this.state.errorclass : "untouched"} onChange={this.onInputFieldChange} aria-label="Floor you are moving to">
                      <option disabled value="0">Select Floor</option>
                      {firstStepConstants.moveSizesHouseFloor.map(option =>
                        <option name="movingToFlights" key={option.value + 'flightsto1'} value={option.floor}>{option.label}</option>
                      )}
                    </select>
                  </div>
                </div>

                <div className="md-select-wrapper md-moving-real-half">
                  <DatePicker id="thedate" placeholderText="Moving Date" minDate={moment()} defaultValue={this.state.movingDate || null} selected={this.state.movingDate ? moment(this.state.movingDate) : null} className={!this.state.movingDate ? this.state.errorclass : "untouched"} onChange={this.onDateChange} />
                </div>

              </div>

            </div>
          </div>
        </div>
        <div className="holder">
          <div className="steps-navigation qc-first-step-nav">
            <Button bsStyle="primary" bsSize="large" type="submit" onClick={this.handleNext}>get quote</Button>
          </div>
        </div>
      </div>

    );
  }
}

export default FirstStep;



// WEBPACK FOOTER //
// ./src/steps/FirstStep.js